import debounce from 'lodash.debounce';

(function($, window) {


  let _slice = [].slice;
  let _toString = {}.toString;

  let FixedPageTopView = (function() {

    function FixedPageTopView() {
      this._init.apply(this, arguments);
    }

    FixedPageTopView.dataName = 'FixedPageTopView';
    FixedPageTopView.defaultOptions = {

    };

    FixedPageTopView.prototype = {
      constructor: FixedPageTopView,

      _init: function($element, options) {
        this.$element = $element;
        this.$window = $(window);
        this.wideMq = window.matchMedia( '(min-width: 768px)' );
        this.narrowMq = window.matchMedia( '(max-width: 767px)' );
        this.upperWaypoint = null;
        this.lowerWaypoint = null;

        this._lastScrollPosition = 0;
        this._crossUpperWaypoint = false;
        this._crossLowerWaypoint = false;

        this._handleEnterWideViewport = this._handleEnterWideViewport.bind(this);
        this._handleEnterNarrowViewport = this._handleEnterNarrowViewport.bind(this);
        this._handleViewportResize = this._handleViewportResize.bind(this);
        this._handleViewportScroll = debounce(this._handleViewportScroll.bind(this), 30);

        this._setup();
      },

      _setup: function() {

        this.$element.addClass('is-fixed');

        if(this.wideMq.matches) {
          this._handleEnterWideViewport(this.wideMq);
        } else if(this.narrowMq.matches) {
          this._handleEnterNarrowViewport(this.narrowMq);
        }

        this._setEvents();
      },

      _setEvents: function() {
        this.wideMq.addListener(this._handleEnterWideViewport);
        this.narrowMq.addListener(this._handleEnterNarrowViewport);
        this.$window.on('resize', debounce(this._handleViewportResize, 50));
      },

      _handleEnterWideViewport: function(mql) {

        if(mql.matches) {

          if(this.lowerWaypoint) {
            this.upperWaypoint.destroy();
            this.lowerWaypoint.destroy();
          }

          this.upperWaypoint = new Waypoint({
            element: document.getElementById('page'),
            handler: this._hitUpperPoint.bind(this),
            offset: -100
          });

          this.lowerWaypoint = new Waypoint({
            element: document.getElementById('pageFooter'),
            handler: this._hitLowerPoint.bind(this),
            offset: function() {
              return Waypoint.viewportHeight() - 40;
            }
          });

          this.$window.off('scroll', this._handleViewportScroll);
        }
      },

      _handleEnterNarrowViewport: function(mql) {

        if(mql.matches) {

          if(this.lowerWaypoint) {
            this.upperWaypoint.destroy();
            this.lowerWaypoint.destroy();
          }

          this.upperWaypoint = new Waypoint({
            element: document.getElementById('page'),
            handler: this._hitUpperPoint.bind(this),
            offset: -100
          });

          this.lowerWaypoint = new Waypoint({
            element: document.querySelector('.pageFooter__copyright'),
            handler: this._hitLowerPoint.bind(this),
            offset: function() {
              return Waypoint.viewportHeight() + 70;
            }
          });

          this._lastScrollPosition = this.$window.scrollTop();
          this.$window.on('scroll', this._handleViewportScroll);
        }
      },

      _handleViewportScroll: function(evt) {
        const currentScrollPosition = this.$window.scrollTop();

        if(this._crossUpperWaypoint && !this._crossLowerWaypoint) {
          if(currentScrollPosition > this._lastScrollPosition) {

            if(this.$element.hasClass('is-visible')) {
              this.$element.removeClass('is-visible');
            }
          } else {
            if(!this.$element.hasClass('is-visible')) {
              this.$element.addClass('is-visible');
            }
          }
        }

        this._lastScrollPosition = currentScrollPosition;
      },

      _handleViewportResize: function(evt) {

        this.upperWaypoint.context.refresh();
        this.lowerWaypoint.context.refresh();

      },

      _hitUpperPoint: function(dir) {

        if(dir === 'up') {
          this.$element.removeClass('is-visible');
          this._crossUpperWaypoint = false;
        }
        else if(dir === 'down') {

          if(this.wideMq.matches) {
            this.$element.addClass('is-visible');
          }

          this._crossUpperWaypoint = true;
        }
      },

      _hitLowerPoint: function(dir) {

        if(dir === 'up') {
          this.$element.addClass('is-fixed');
          this._crossLowerWaypoint = false;
        }
        else if(dir === 'down') {
          this.$element.removeClass('is-fixed');
          this.$element.addClass('is-visible');
          this._crossLowerWaypoint = true;
        }
      },

      destroy: function() {
        this.upperWaypoint.destroy();
        this.lowerWaypoint.destroy();

        this.$element.removeClass('is-fixed is-visible');
      }

    };

    return FixedPageTopView;
  })();

  let methods = {

    init: function(options) {
      options = $.extend(true, {}, FixedPageTopView.defaultOptions, options);

      this.each(function() {
        let $element = $(this);
        $element.data(FixedPageTopView.dataName, new FixedPageTopView($element, options));
      });
    },

    destroy: function() {

      this.each(function() {
        let instance = $(this).data(FixedPageTopView.dataName);

        if(!instance) {
          return;
        }

        instance.destroy();
      });
    }
  };


  $.fn.fixedPageTop = function() {

    let args = _slice.call(arguments);

    let first = args[0];

    let rest = args.length > 1 ? _slice.call(arguments, 1) : [];

    if (!first) {
        methods.init.call(this);
    }

    else if($.isPlainObject(first)) {
        methods.init.apply(this, args);
    }

    else if(_toString.call(first) === '[object String]' && (first in methods)) {
        methods[first].apply(this, rest);
    }

    else {
        $.error('Failed to invoke a method or to initialise plugin.');
    }

    return this;
  };

})(jQuery, window);



// WEBPACK FOOTER //
// ./src/js/jquery-plugin/fixedPageTop.js